var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgExclamationTriangle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 55,
    viewBox: "0 0 60 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M59.325 46.693 34.331 2.547c-1.92-3.396-6.738-3.396-8.662 0L.675 46.693c-1.919 3.39.483 7.64 4.33 7.64h49.989c3.84 0 6.256-4.244 4.331-7.64ZM30 47.542c-.66 0-1.304-.2-1.852-.573a3.384 3.384 0 0 1-1.227-1.524 3.455 3.455 0 0 1-.19-1.962 3.416 3.416 0 0 1 .912-1.738 3.316 3.316 0 0 1 1.707-.93 3.277 3.277 0 0 1 1.926.194c.609.257 1.13.692 1.496 1.25a3.445 3.445 0 0 1-.415 4.288 3.303 3.303 0 0 1-2.357.995Zm3.983-25.3L32.65 35.825a1.71 1.71 0 0 1-.54 1.09 1.65 1.65 0 0 1-1.118.44h-1.98a1.65 1.65 0 0 1-1.118-.44 1.71 1.71 0 0 1-.54-1.09l-1.333-13.583a1.727 1.727 0 0 1 .421-1.307 1.64 1.64 0 0 1 1.233-.56h4.65a1.64 1.64 0 0 1 1.236.559 1.705 1.705 0 0 1 .422 1.308Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.325 20.375h-4.65a1.64 1.64 0 0 0-1.235.559 1.705 1.705 0 0 0-.423 1.308l1.333 13.583c.041.419.234.807.54 1.09a1.65 1.65 0 0 0 1.119.44h1.979a1.65 1.65 0 0 0 1.118-.44 1.71 1.71 0 0 0 .54-1.09l1.334-13.583a1.727 1.727 0 0 0-.422-1.307 1.642 1.642 0 0 0-1.233-.56ZM30 40.75c-.659 0-1.303.2-1.852.572a3.383 3.383 0 0 0-1.227 1.524 3.455 3.455 0 0 0-.19 1.962c.129.66.446 1.264.912 1.739a3.32 3.32 0 0 0 1.707.93 3.277 3.277 0 0 0 1.926-.194 3.348 3.348 0 0 0 1.496-1.25 3.441 3.441 0 0 0-.415-4.288A3.303 3.303 0 0 0 30 40.75Z",
    fill: "url(#c)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 30.001,
    y1: 0,
    x2: 30.001,
    y2: 54.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 29.998,
    y1: 20.375,
    x2: 29.998,
    y2: 47.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v54.333H0z"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgExclamationTriangle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/exclamation-triangle.0cd9c081b8e14f6414e61d7c8ee33b8f.svg";